import React from "react";
import { sortBy } from "lodash";
import Button from "@mui/material/Button";

import { useCurrentGame } from "../../../hooks/useCurrentGame";
import { useDeclarer } from "../../../hooks/useDeclarer";
import { RUFER_OPTIONS } from "../../../constants";
import { selectIAmDeclarer } from "../../../store/selectors";
import { useSelector } from "react-redux";

export const RuferOptionPicker: React.FC = () => {
  const { setRuferOption } = useCurrentGame();
  const { declarer } = useDeclarer();

  const iAmDeclarer = useSelector(selectIAmDeclarer);

  // should never happen
  if (declarer === undefined) {
    return <div className="text-emerald-200 animate-pulse">Loading declarer...</div>;
  }

  if (!iAmDeclarer) {
    return (
      <div className="text-emerald-100 text-lg font-medium animate-pulse">
        Waiting for {declarer.name} to pick a Rufer option...
      </div>
    );
  }

  return (
    <div className="text-center">
      <h2 className="text-2xl font-bold mb-6 text-white">Choose Rufer Option</h2>
      <div className="flex flex-wrap items-center justify-center gap-3">
        {sortBy(RUFER_OPTIONS, ({ points }) => points).map((bid) => (
          <Button
            key={bid.slug}
            variant="contained"
            className="!rounded-full"
            onClick={() => setRuferOption(bid.slug)}
            sx={{
              backgroundColor: '#059669',
              '&:hover': { backgroundColor: '#047857' },
              px: 3,
              py: 1,
            }}
          >
            {bid.name}
          </Button>
        ))}
      </div>
    </div>
  );
};
